export const ActivityParticipantRoles = [
    'facilitator',
    'minuteTaker',
    'participant'
] as const;

export type ActivityParticipantRole = typeof ActivityParticipantRoles[number];

export type ActivityParticipantData =
{
    id:string,
    type:
        { value:'internal', userId:string } |
        { value:'external' },
    activityRole:ActivityParticipantRole,
    name:string,
    role:string,
    email:string
};

export type InternalActivityParticipant = 
{
    type:'internal',
    id:string,
    userId:string,
    activityRole:ActivityParticipantRole
}

export type externalActivityParticipant =
{
    type:'external',
    id:string,
    activityRole:ActivityParticipantRole,
    name:string,
    role:string,
    email:string
}

export type ActivityParticipant = 
    InternalActivityParticipant | externalActivityParticipant;